import { PushNotificationsComponent } from './../../pages/admin/push-notifications/push-notifications.component';
import { ModalModule } from './../modal/modal.module';
import { BillingHistoryComponent } from './../../pages/admin/billing-history/billing-history.component';
import { DeviceOrderComponent } from './../../pages/admin/device-order/device-order.component';
import { UserComponent } from './../../pages/admin/user/user.component';
import { OrganisationEditComponent } from './../../pages/admin/organisation/edit/edit.component';
import { OrganisationListingComponent } from './../../pages/admin/organisation/listing/listing.component';
import { SeriesEditComponent } from './../../pages/admin/series/edit/edit.component';
import { SeriesListingComponent } from './../../pages/admin/series/listing/listing.component';
import { ChallengeReportComponent } from './../../pages/admin/challenge-report/challenge-report.component';
import { SidebarComponent } from './../../pages/admin/sidebar/sidebar.component';
import { DashboardComponent } from './../../pages/admin/dashboard/dashboard.component';
import { NavigationComponent } from './../../partials/navigation/admin-navigation/admin-navigation.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminRoutingModule } from './admin-routing.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from 'src/app/interceptors/token.interceptor';
import { ErrorInterceptor } from 'src/app/interceptors/error.interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CustomAdapter } from 'src/app/helpers/date-picker/custom-adapter';
import { CustomDateParserFormatter } from 'src/app/helpers/date-picker/custom-date-parser-formatter';
import { PlyrModule } from 'ngx-plyr';
import { MinuteSecondsPipe } from 'src/app/helpers/pipes/minuteSeconds.pipe';
import { SortablejsModule } from 'ngx-sortablejs';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { ListingComponent as AudioListing, ViewComponent as AudioView, CreateComponent as AudioCreate } from './../../pages/admin/resources/audio-pods';
import { ListingComponent as ScienceListing, ViewComponent as ScienceView, CreateComponent as ScienceCreate } from './../../pages/admin/resources/science';
import { ListingComponent as CommunityListing, ViewComponent as CommunityView, CreateComponent as CommunityCreate } from './../../pages/admin/resources/community';

@NgModule({
  declarations: [
    NavigationComponent,
    SidebarComponent,
    DashboardComponent,
    SeriesListingComponent,
    SeriesEditComponent,
    OrganisationListingComponent,
    OrganisationEditComponent,
    UserComponent,
    DeviceOrderComponent,
    BillingHistoryComponent,
    ChallengeReportComponent,
    MinuteSecondsPipe,
    AudioListing,
    AudioView,
    AudioCreate,
    CommunityListing,
    CommunityView,
    CommunityCreate,
    ScienceListing,
    ScienceView,
    ScienceCreate,
    PushNotificationsComponent
  ],
  imports: [
    CommonModule,
    AdminRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    ColorPickerModule,
    NgbModule,
    PlyrModule,
    ModalModule,
    SortablejsModule,
    EditorModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }
  ],
})
export class AdminModule { }
